import { render, staticRenderFns } from "./a-contenido.vue?vue&type=template&id=6abf2290&"
import script from "./a-contenido.vue?vue&type=script&lang=ts&"
export * from "./a-contenido.vue?vue&type=script&lang=ts&"
import style0 from "./a-contenido.vue?vue&type=style&index=0&id=6abf2290&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
